import React, { useState } from "react"

import MagGlass from "../images/magGlass.svg"
import Modal from "./Modal"
import EmployeeCard from "./EmployeeCard"

const people = require("../fixtures/people.json")
function SearchForm() {
  const [searchVal, setSearchVal] = useState("")
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedPerson, setSelectedPerson] = useState({})

  const handleChange = (event) => {
    setSearchVal(event.currentTarget.value)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    if (people.filter(findPeople).length > 0) {
      setSelectedPerson(people.filter(findPeople)[0])
      setModalOpen(true)
    }
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setSelectedPerson({})
  }

  const handleNameClick = (person) => {
    setSelectedPerson(person)
    setModalOpen(true)
  }

  const findPeople = (person) => {
    if (searchVal.length > 0) {
      return (
        person.lastName.toLowerCase().startsWith(searchVal.toLowerCase()) ||
        person.firstName.toLowerCase().startsWith(searchVal.toLowerCase()) ||
        `${person.firstName} ${person.lastName}`
          .toLowerCase()
          .startsWith(searchVal.toLowerCase())
      )
    } else {
      return false
    }
  }

  return (
    <div className='search-form'>
      <Modal
        show={modalOpen}
        onClose={handleCloseModal}
        title='Search form'
        showConfetti={true}
      >
        <EmployeeCard onClose={handleCloseModal} person={selectedPerson} />
      </Modal>
      <form onSubmit={handleSubmit} className="search-form__form">
        <input
          className="search-form__form__input"
          type='text'
          id='search'
          name='search'
          placeholder='Search by name'
          value={searchVal}
          onChange={handleChange}
        />
        <div className='search-form__icon'>
          <img src={MagGlass} alt='mag glass' />
        </div>
      </form>
      <div
        className={`search-form__results search-form__results--${
          searchVal.length > 0 ? "visible" : "invisible"
        }`}
      >
        <ul className="search-form__results__list">
          {people.filter(findPeople).map((person, i) => {
            if (i < 7) {
              return (
                <li
                  className='search-form__results__list__item'
                  onClick={() => handleNameClick(person)}
                  key={`search-result-${person.firstName}-${person.lastName}-${i}`}
                >
                  {person.firstName} {person.lastName}
                </li>
              )
            }
          })}
        </ul>
      </div>
    </div>
  )
}

export default SearchForm
